import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"


const initialState = { status: null, loading: false, data: [], error: "", message: '' }


export const forgetPasswordAction = createAsyncThunk(
    'forgot-password',
    async (data, { rejectWithValue }) => {
        console.log("dataforget-->",data)
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/auth/forget/password`, {email: data?.email})
            //const res = await axios.post(`/support-server/api/register-admin`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const forgetPasswordSlice = createSlice({
    name: 'forgot-password',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(forgetPasswordAction.pending, (state) => {

                state.loading = true
            })
            builder.addCase(forgetPasswordAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(forgetPasswordAction.rejected, (state, action) => {
                state.loading = false
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.error = action?.payload?.message
            })
        },

})



export const forgetPasswordReducer = forgetPasswordSlice.reducer